// This logic matches our logic for filtering by tenant tags as described here:
// https://octopus.com/docs/reference/tenant-tags#TenantTags-Tag-basedfilters
// Ideally, we should be using this function anywhere we filter by tenant tags on the client
export default function tenantMatchesFilter(tenantTags: string[], filterBy: TagsGroupedByTagSet) {
    return filterBy.every(tagSet => tagSet.some(t => tenantTags.includes(t)));
}

type Tags = string[];
type TagsGroupedByTagSet = Tags[];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/tenants/TenantMatchesFilter.ts